import messageWatcher from './messageWatcher';

const init = (window, chatControl) => {
  messageWatcher.init(window, {
    getStoredData: () => ({
      getHtml: () => chatControl.predictionAnswerHtml,
      getControl: () => chatControl.predictionAnswerControl,
      setControl: ({ text, renderedBy }) => (
        chatControl.setPredictionAnswerControl({ text, renderedBy })
      ),
    }),
  });
};

export default { init };
